function Divider() {
  return (
    <div className="py-3">
      <hr />
    </div>
  );
}

export default Divider;
